import { Header, Text } from '@opengov/component-library/capital';
import React from 'react';

import { IStoriesNamespace } from '../../locale';

import { Gear } from './Gear';
import styles from './Maintenance.scss';
import { Story } from './Story';
import { PageErrorBoundary } from '../../stories/components/ErrorBoundary/PageErrorBoundary';
import { ViewName } from '../../instrumentation/views';

const colorGray500 = '#9A9DA1';
const colorPrimaryBrand = '#165CAB';

export interface IMaintenanceProps {
  messages: IStoriesNamespace;
}

const MaintenanceInternal: React.FC<IMaintenanceProps> = props => {
  const msg = props.messages.storiesPage;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div id="skipToContent">
          <a href="#mainContent">{msg.skipTo}</a>
        </div>
        <Header variant="h1">{msg.title}</Header>
      </div>
      <div role="main" id="mainContent" className={styles.content}>
        <div className={styles.container}>
          <div className={styles.illustration}>
            <Story className={styles.story} />
            <Gear className={styles.gear1} fill={colorGray500} />
            <Gear className={styles.gear2} fill={colorPrimaryBrand} />
          </div>
          <div className={styles.message}>
            <Header variant="h2" className={styles.text}>
              {msg.improvingExperience}
            </Header>
            <Text as="p" className={styles.text}>
              {msg.scheduledMaintenence}
            </Text>
            <Text as="p" className={styles.text}>
              {msg.publishedStories}
            </Text>
            <Text as="p" className={styles.text}>
              {msg.pleaseContact} <a href="mailto:support@opengov.com">support@opengov.com</a> {msg.withAnyQuestions}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Maintenance: React.FC<IMaintenanceProps> = props => {
  return (
    <PageErrorBoundary viewName={ViewName.MaintenancePage}>
      <MaintenanceInternal {...props} />
    </PageErrorBoundary>
  );
}
